import React, {  useState, useEffect } from "react";
import "../css/registro.css";
import Logo from "../../SVG/Logocircular.svg";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch} from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import OperationStatus from "../../config/OperationStatus";
import { reiniciarContrasenaSolicitud } from "../../redux/usuariosSlice";
import Required from "../../Components/Required";
import { getLoginPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";

import { useValidation } from "../../Hooks/useValidation";
export default function RecuperarContrasena() {
  const { validation } = useValidation();
  const { locale } = useLocale();
  const [loginPage, setloginPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      correo: "",
    },
  });
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    let { payload } = await dispatch(reiniciarContrasenaSolicitud(data));

    if (payload.operationStatus === OperationStatus.SUCCESS) {
      toast.success(payload.message);
      setSuccess(true);
    } else {
      toast.error(payload.message);
    }
  };

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getLoginPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setloginPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setloginPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  if (isLoadingContent) {
    return (
      <div className="reset-container">
        <div className="reset-card">
          <div>
            <div className="mt-4">
              <Skeleton.Image style={{ width: 100, height: 100 }} active />
            </div>
            <br />
            <Skeleton.Input style={{ width: 200, height: 30 }} active />
          </div>
          <div className="reset-form-container">
            <div className="mb-2">
              <Skeleton.Input style={{ width: 300, height: 20 }} active />
            </div>
            <div className="form-group">
              <Skeleton.Input style={{ width: 150, height: 20 }} active />
              <Skeleton.Input style={{ width: '100%', height: 40 }} active />
            </div>
            <Skeleton.Button style={{ width: 200, height: 40 }} active />
            <Skeleton.Input style={{ width: 120, height: 20 }} active />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-container">
      <div className="reset-card">
        <div>
          <div className="mt-4">
            <img
              onClick={() => {
                navigate("/Login");
              }}
              className="reset-image"
              src={Logo}
              alt="Logo"
            />
          </div>
          <br />

          {!success && <span className="subtitle">{loginPage?.resetPasswordPage?.title || "Recuperar contraseña"}</span>}
        </div>
        <div className="reset-form-container">
          {!success ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-2">
                <span className="spanInfo">
                  {loginPage?.resetPasswordPage?.description || "Escribe tu correo electrónico para enviarte el enlace de restauración de contraseña"}
                </span>
              </div>

              <div className="form-group">
                <label>{loginPage?.resetPasswordPage?.email || "Correo electrónico"}</label>
                <Required />
                <input
                  className="form-control"
                  autoComplete="email"
                  type="email"
                  {...register("correo", {
                    required: validation?.required_field || "Campo requerido",
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: "Escriba un correoElectronico valido",
                    },
                  })}
                />
                {errors.correo && (
                  <p className="error">{errors.correo.message}</p>
                )}
              </div>

              <input
                type="submit"
                id="btnForm"
                value={loginPage?.resetPasswordPage?.send_button || "Enviar enlace de acceso"}
              />
              <h5>
                <Link to="/Login" className="text-primary">
                  {loginPage?.resetPasswordPage?.back_button || "Volver atrás"}
                </Link>
              </h5>
            </form>
          ) : (
            <div className="mt-4">
              <span className="subtitle">
                {loginPage?.final_message || "Se ha enviado un enlace de recuperación a su correo electrónico"}
              </span>
              <span className="sub-info d-block mt-4">
                {loginPage?.close_page || "Puede cerrar esta pestaña"}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
